import { useContext } from "react";
import Select from "react-select";
import CmsContext from "../../Context/CmsContext";
import { useEffect } from "react";
import ApiService from "../../Core/Service/ApiService";
import { CmsType } from "../../Constants/constants";
import { useState } from "react";
import { MDBBtn, MDBCard, MDBCardBody, MDBCardHeader, MDBCardTitle, MDBCheckbox, MDBInput, MDBSpinner } from "mdb-react-ui-kit";
import { validateForm } from "../../Utils/utils";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Ribbon from "../../Components/CMS/Ribbon";
import ColorPicker from "../../Components/CMS/ColorPicker";

const ShopByCategory = () => {
    const navigate = useNavigate();
    const cmsContext = useContext(CmsContext);
    const [formData, setFormData] = useState({
        type: CmsType.Shop_By_Category,
        active: false,
        start_date: '1970-01-01 00:00:00',
        end_date: '2100-12-31 00:00:00',
        page_pos: 0,
        branches: 'all',
        organization: 0,
        template_id: '',
        ribbon: {
            content: '',
            bg_color: '#f00',
            txt_color: '#fff',
            align: 'left',
        },
        data: {}
    });
    const rules = {
        page_pos: {required: 'number'}
    }
    const [inputErrors, setInputErrors] = useState({});
    const ribbonAlignOptions = [
        { value: 'left', label: 'Left'},
        { value: 'center', label: 'Center'},
        { value: 'right', label: 'Right'},
    ]
    const [templateOptions, setTemplateOptions] = useState();
    const [saving, setSaving] = useState(false);

    const loadData = async () => {
        ApiService.get('/cms', {type: CmsType.Shop_By_Category}).then(response => {
            if(response.data.rows?.length > 0) {
                const row = response.data.rows[0];
                setFormData({
                    ...formData,
                    ...row,
                    active: (row.active == "1") ? true : false,
                    start_date: '1970-01-01 00:00:00',
                    end_date: '2100-12-31 00:00:00',
                    branches: 'all',
                    organization: 0,
                    ribbon: row.ribbon ? JSON.parse(row.ribbon) : {},
                    data: row.data ? JSON.parse(row.data) : {},
                });
            }
        })

        ApiService.get('/templates/all').then(response=>{
            const ts = response.data.templates;
            ts.unshift({
                id: '', internal_name: '- None -'
            });
            setTemplateOptions(ts.map(t=>(
                {value: t.id, label: t.internal_name}
            )));
        })
    }

    useEffect(() => {
        cmsContext.setBreadcrumb([
            {title: 'Shop by Category'},
        ]);

        loadData();
    }, [])

    const handleCheckChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.checked
        })
    }
    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }
    const handleSelectChange = (opt, target) => {
        setFormData({
            ...formData,
            [target]: opt.value
        })
    }
    const setRibbon = (ribbon) => {
        setFormData({
            ...formData,
            ribbon: ribbon
        })
    }

    const goBack = () => {
        navigate(-1);
    }
    
    const handleSave = async () => {
        const ret = validateForm(formData, rules);
        if (ret.result) {
            setInputErrors({});
            setSaving(true);

            const data = {
                ...formData,
                ribbon: JSON.stringify({
                    bg_color: '#f00',
                    txt_color: '#fff',
                    align: 'left',
                    ...formData.ribbon
                }),
                data: JSON.stringify(formData.data),
            }

            const url = formData.id ? `/cms/save/${formData.id}` : `/cms/create`;
            if(formData.id) {
                await ApiService.put(`/cms/${formData.id}`, data);
            } else {
                await ApiService.post('/cms', data);
            }
            
            toast.success("Operation Success");
            setSaving(false);
        } else {
            setInputErrors(ret.errors);
        }
    }

    const renderCommon = () => {
        return (
        <MDBCard>
            <MDBCardHeader>
                <MDBCardTitle>Common</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
                <div className="d-flex align-items-center">
                    <div className="d-flex align-items-center">
                        <label className="me-2">Active:</label>
                        <MDBCheckbox name="active" checked={formData.active} onChange={handleCheckChange} title='Activate/Deactivate the CMS content' />
                    </div>
                    <div className="ms-4">
                        <div className="d-flex align-items-center">
                            <label className="me-2 required">Page Position:</label>
                            <div style={{ width: 100 }}>
                                <MDBInput name="page_pos" value={formData.page_pos ?? 1} onChange={handleInputChange} type="number" className="text-center" />
                            </div>
                        </div>
                        {inputErrors?.page_pos && <div className="error">{inputErrors.page_pos}</div>}
                    </div>
                    <div className="ms-4 d-flex align-items-center">
                        <label className="me-2">Template:</label>
                        <div style={{width: 150}}>
                            <Select options={templateOptions} 
                                value={templateOptions?.find(opt => opt.value == formData.template_id)} 
                                onChange={opt=>handleSelectChange(opt, 'template_id')}
                            />
                        </div>
                    </div>
                </div>
            </MDBCardBody>
        </MDBCard>
        )
    }

    return (
    <div className="p-4">
        { renderCommon() }

        <Ribbon ribbon={formData.ribbon ?? {}} setRibbon={setRibbon} />

        <MDBCard className="mt-4">
            <MDBCardBody>
                <ColorPicker 
                    label="Label Color: "
                    color={formData.data?.label?.txt_color} 
                    setColor={(color) => {
                        setFormData({
                            ...formData,
                            data: {
                                ...formData.data,
                                label: {
                                    txt_color: color
                                }
                            }
                        })
                    }} 
                />
            </MDBCardBody>
        </MDBCard>        

        <div className="mt-4 d-flex justify-content-end">
            <MDBBtn color="default" onClick={goBack}>Back</MDBBtn>
            <MDBBtn className="ms-2 united-cms-primary-btn" onClick={handleSave}>
                {saving && <MDBSpinner size="sm" className="me-1" />}
                Save
            </MDBBtn>
        </div>
    </div>
    )
}

export default ShopByCategory;
